import BreadcrumbConnected from './BreadcrumbConnected'
export default BreadcrumbConnected
